// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_af-2";
export var aiChatCartContainerExit = "_af-4";
export var aiChatContainerLarge = "_af-0";
export var aiChatContainerSmall = "_af-1";
export var aiChatIcon = "_af-6";
export var slideInFromRight = "_af-3";
export var slideOutToRight = "_af-5";